import script from "./HobbiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HobbiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./HobbiesComponent.vue?vue&type=style&index=0&id=8af47e5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af47e5a"]])

export default __exports__